export const pt = {
  title: 'Histórico de faturas',
  back: 'Voltar',
  error: 'Falha ao carregar os dados de ingresso do evento. {{code}}',
}
